import React from "react";
import { useState, useCallback } from "react";
import { apiCall } from "../../services/api";
import { useEffect } from "react";
import {
  Button,
  Switch,
  FormControlLabel,
  Typography,
} from "@material-ui/core";

const useLogs = (isProduction) => {
  const [logs, setLogs] = useState([]);

  const fetchLogs = useCallback(async () => {
    const { logs } = await apiCall("GET", "/api/docusign-admin/logs", {
      params: {
        type: isProduction ? "docusign-prd" : "docusign-test",
      },
    });
    setLogs(logs);
  }, [isProduction]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  return { logs, fetchLogs };
};

const formatLog = (log) => {
  try {
    // Try to parse if it's a string
    const parsedLog = typeof log === "string" ? JSON.parse(log) : log;
    return JSON.stringify(parsedLog, null, 2);
  } catch (e) {
    // If parsing fails, return the original log
    return typeof log === "string" ? log : JSON.stringify(log, null, 2);
  }
};

export const DisplayLogs = () => {
  const [isProduction, setIsProduction] = useState(false);
  const { logs, fetchLogs } = useLogs(isProduction);

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h1 style={{ fontSize: 16 }}>Logs</h1>
          <FormControlLabel
            control={
              <Switch
                checked={isProduction}
                onChange={(e) => setIsProduction(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography style={{ fontSize: "14px", color: "gray" }}>
                {isProduction ? "Production" : "Test"}
              </Typography>
            }
          />
        </div>
        <div>
          <Button variant="contained" color="primary" onClick={fetchLogs}>
            Refresh
          </Button>
        </div>
      </div>
      <div>
        {logs.map((log) => (
          <pre
            key={log.id}
            style={{
              backgroundColor: "#f5f5f5",
              padding: "15px",
              borderRadius: "4px",
              border: "1px solid #ddd",
              marginBottom: "10px",
              overflowX: "auto",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          >
            {log.type} - {log.timestamp} <br />
            {formatLog(log.error)}
          </pre>
        ))}
      </div>
      <div style={{ height: "2rem", flexShrink: 0 }} />
    </div>
  );
};
